export default function PageHeader({ title, subtitle, action, leading, className = '' }) {
  return (
    <div className={`flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6 ${className}`}>
      <div className="flex items-center gap-3">
        {leading && <div className="flex-shrink-0">{leading}</div>}
        <div>
          <h1 className={`text-page-title font-display text-ink`}>{title}</h1>
          {subtitle && <p className="text-body mt-1 text-ink-muted">{subtitle}</p>}
        </div>
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  );
}
